import * as consts from './MainConsts';

const initialState = {
    backgroundPhoto: null,
    title: '',
    lotSize: '',
    baths: '',
    bedrooms: '',
    address: {
        full: '',
        city: '',
        state: '',
        street: '',
        zip: ''
    },
    description: '',
    descriptionPlain: '',
    price: {
        type: '',
        value: 0,
        from: 0,
        to: 0
    },
    sqft: {
        type: '',
        value: 0,
        from: 0,
        to: 0
    },
    listingId: 0,
    listingType: '',
    listingStatus: '',
    propertyType: '',
    basementType: '',
    garageBays: '',
    additionalGarageBays: '',
    halfBath: '',
    floorsAboveGround: 0,
    features: {
        exterior: {},
        interior: {}
    },
    startComponentRender: false
};
const main = (state = initialState, action) => {
     switch (action.type) {
        case consts.GET_BACKGROUND_PHOTO_FULFILLED:
            return {
                ...state,
                backgroundPhoto: action.payload
            }
        case consts.CHANGE_COMPONENT:
            return {
                ...state,
                startComponentRender: action.payload
            }

        default:
            return state
    }
}

export default main;
